export const styles = {
  pageWrapper: {
    paddingTop: {
      xs: "15px",
      sm: "30px",
    },
    paddingBottom: "30px",
  },

  contentPadding: {
    padding: {
      xs: "10px 0 20px",
      sm: "10px 0 20px",
      md: "10px 0 20px",
      lg: 0,
      xl: 0,
    },
  },

  gridItem: {
    margin: {
      xs: "0 auto 30px",
      sm: "0 auto 45px",
    },
  },

  card: {
    boxShadow: "0 20px 20px 0 #2A48761A",
    backgroundColor: "#ffffff",
    padding: "20px",
    width: "100%",
    display: "flex",
    borderRadius: "20px",
    flexDirection: {
      xs: "column",
      sm: "row",
    },
  },

  leftColumn: {
    width: {
      xs: "100%",
      sm: "50%",
      lg: "40%",
    },
  },

  imageContainer: {
    position: "relative",
    borderRadius: "20px",
    overflow: "hidden",
    height: {
      xs: "200px",
      sm: "200px",
      md: "250px",
      lg: "200px",
    },
  },

  eventTypeBadge: {
    position: "absolute",
    top: "10px",
    right: "10px",
    padding: "10px 20px",
    borderRadius: "50px",
    background: "#fff",
    fontSize: "14px",
    fontWeight: 400,
    color: "#2A4876",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  imageOverlay: {
    background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 5.83%, #000000 100%)",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
  },

  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "100%",
    borderRadius: "20px",
    overflow: "hidden",
    cursor: "pointer",
  },

  eventImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  playButton: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "50%",
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  detailsSection: {
    paddingTop: "20px",
  },

  eventTitle: {
    color: "#2A4876",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "31px",
  },

  sectionLabel: {
    color: "#000000",
    fontSize: {
      xs: "15px",
      sm: "15px",
      md: "16px",
      lg: "18px",
      xl: "20px",
    },
    fontWeight: 600,
  },

  eventUrlText: {
    color: "#2A4876",
    fontSize: {
      xs: "15px",
      sm: "15px",
      md: "16px",
      lg: "18px",
      xl: "20px",
    },
    marginBottom: "10px",
  },

  priceOriginal: (showStrikethrough) => ({
    textDecoration: showStrikethrough ? "line-through" : "none",
    color: "#2A4876",
    fontSize: "14px",
    fontWeight: 500,
    marginBottom: "4px",
    marginTop: "5px",
  }),

  priceDiscountBadge: (isSponsor) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#2A4876",
    padding: "5px 10px",
    borderRadius: "10px",
    marginBottom: "10px",
    marginTop: "10px",
    marginLeft: !isSponsor ? "5px" : "0px",
  }),

  priceDiscountText: {
    color: "#fff",
    fontSize: "14px",
    fontWeight: 600,
  },

  timeRow: {
    display: "flex",
    alignItems: "center",
  },

  dateRow: {
    display: "flex",
    alignItems: "center",
    paddingTop: "10px",
  },

  icon: {
    width: "18px",
    height: "18px",
  },

  metaText: {
    color: "#000",
    fontSize: "14px",
    fontWeight: 400,
    paddingLeft: "10px",
  },

  sponsorRow: {
    display: "flex",
    alignItems: "center",
  },

  sponsorLogo: {
    width: "26px",
    height: "26px",
    objectFit: "cover",
    borderRadius: "50px",
  },

  sponsorName: {
    color: "#2A4876",
    fontSize: "14px",
    fontWeight: 600,
    paddingLeft: "10px",
  },

  rightColumn: {
    width: {
      xs: "100%",
      sm: "60%",
    },
    paddingLeft: "30px",
    textAlign: "left",
  },

  descriptionContainer: {
    marginTop: "10px",
    height: {
      xs: "200px",
      sm: "300px",
      md: "400px",
      lg: "400px",
      xl: "450px",
    },
    overflow: "auto",
  },

  descriptionContent: {
    color: "#2A4876",
    fontSize: {
      xs: "15px",
      sm: "15px",
      md: "16px",
      lg: "18px",
      xl: "20px",
    },
    marginBottom: "10px",
    whiteSpace: "pre-line",
    "& ul": {
      listStyleType: "disc",
      paddingLeft: "20px",
      marginBottom: "10px",
    },
    "& ol": {
      listStyleType: "decimal",
      paddingLeft: "20px",
      marginBottom: "10px",
    },
    "& li": {
      marginBottom: "6px",
    },
  },

  participantCount: {
    color: "#2A4876",
    fontSize: {
      xs: "15px",
      sm: "15px",
      md: "16px",
      lg: "18px",
      xl: "20px",
    },
    marginBottom: "15px",
  },

  ctaButtonDisabled: {
    backgroundColor: "#AAB6C8",
    padding: "20px 40px",
    width: "100%",
    borderRadius: "50px",
    height: "60px",
    color: "#fff !important",
    fontSize: "18px",
    fontWeight: 500,
    textTransform: "capitalize",
  },

  ctaButtonJoin: {
    backgroundColor: "#7BB9D5",
    padding: "20px 40px",
    width: "100%",
    borderRadius: "50px",
    height: "60px",
    color: "#152134",
    fontSize: "18px",
    fontWeight: 500,
    textTransform: "capitalize",
  },

  ctaButtonPrimary: {
    backgroundColor: "#2A4876",
    padding: "20px 40px",
    width: "100%",
    borderRadius: "50px",
    height: "60px",
    color: "#fff",
    fontSize: "18px",
    fontWeight: 600,
    textTransform: "capitalize",
  },

  ctaButtonPrimaryWhite: {
    backgroundColor: "#2A4876",
    padding: "20px 40px",
    width: "100%",
    borderRadius: "50px",
    height: "60px",
    color: "#fff !important",
    fontSize: "18px",
    fontWeight: 500,
    textTransform: "capitalize",
  },
};
